import { defaultTheme } from '@classify/react-core-components/Theme';
import { alpha } from '@classify/react-core-components/styles';
import fonts from './constants/typographies/fonts';

const brandColorTransparent = alpha(defaultTheme.palette.brand.main, 0.04);

const components = {
  MuiCssBaseline: {
    '@global': {
      '*': {
        outlineColor: defaultTheme.palette.brand.primary,
      },
      body: { color: defaultTheme.palette.text.onMain },
    },
  },
  MuiWithWidth: {
    defaultProps: {
      initialWidth: 'xs',
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        paddingTop: 4,
        paddingBottom: 4,
        [defaultTheme.breakpoints.up('sm')]: {
          minHeight: 48,
        },
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      textSizeSmall: {
        padding: [[4, 8]],
      },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      arrow: {
        color: defaultTheme.palette.text.onMain,
      },
      tooltip: {
        backgroundColor: defaultTheme.palette.text.onMain,
      },
    },
  },
  MuiFilledInput: {
    styleOverrides: {
      root: {
        backgroundColor: brandColorTransparent,
        border: `1px solid ${defaultTheme.palette.stroke}`,
        borderBottom: 0,
        '&$focused': {
          backgroundColor: defaultTheme.palette.background.primary,
          '& $input': {
            backgroundColor: brandColorTransparent,
          },
        },
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        opacity: 1,
        [defaultTheme.breakpoints.up('sm')]: {
          minWidth: 120,
        },
      },
    },
  },
  MuiLink: {
    defaultProps: {
      underline: 'hover',
    },
  },
};

const typography = {
  fontWeightLight: fonts.WEIGHT.REGULAR - 1,
  fontWeightRegular: fonts.WEIGHT.REGULAR,
  fontWeightMedium: fonts.WEIGHT.MEDIUM,
  fontWeightBold: fonts.WEIGHT.BOLD,
  ...defaultTheme.typography,
};

export default {
  ...defaultTheme,
  typography,
  components,
};
